import { AccessAlarm } from "@material-ui/icons";
import ReplyIcon from "@material-ui/icons/Reply";
import styled from "styled-components";

interface TitleProps {
  fontSize?: number;
}
export const Imagem = styled.img`
  top: 0;
  left: 0;
  width: 100%;
`;

export const Back = styled(ReplyIcon)`
  color: #000;
  font-size: xx-large !important;
  &:hover {
    transition: 2ms;
    color: white;
    background-color: blue;
    filter: contrast(200%) brightness(150%);
  }
`;

export const Icone = styled(AccessAlarm).attrs((props) => ({
  fontSize: "inherit",
}))`
  font-size: 40rem;
  width: 50em;
  height: 50em;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  margin: 0 1%;
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 425px) {
    grid-template-columns: 1fr;
  }
`;

export const Person = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 400px;
  max-width: 450px;

  &:hover {
    cursor: pointer;
  }
`;

export const Information = styled.div`
  display: flex;
  width: 80%;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
  /* background-color: red; */
`;

export const Picture = styled.img`
  max-width: 70%;
  max-height: 70%;
  display: flex;
  margin: 0px;
  border-radius: 3px;
  &&:hover {
    transition: 10ms;
    filter: contrast(200%) brightness(150%);
  }
`;

export const Title = styled.p`
  font-size: ${(props: TitleProps) => `${props.fontSize}px`};
  color: ${(props) => props.theme.colors.text};
  font-weight: bold;
  margin: 0px 0px;
  text-transform: capitalize;
  text-justify: auto;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  font: bold;
  letter-spacing: 1px;
  /* color: ${(props) => props.theme.colors.text}; */
  color: #000222;
  font-weight: bold;
  margin: 1px 10px;
`;

export const Endereco = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 300;
  max-width: 80%;
  margin: 0px 0px;
  text-justify: auto;
`;

export const Telefone = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
  font-weight: bold;
  margin: 0px 0px;
  text-justify: auto;
  letter-spacing: 2px;
`;

export const Description = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
  margin: 10px 30px;
`;
